<template lang="pug">
b-container.p-0.mt-1(fluid)
  div.font9.border.rounded-lg.p-2(v-if="!editing" )
    div.d-flex.justify-content-between(v-if="'url'===display_type")
      div.text-primary(v-b-hover="handleHover" :style="hovered ? 'cursor: pointer': ''" @click="toggleEdit" ) {{ label }}
      b-link( :href="entity[property_name]" target="_blank") {{ entity[property_name] }}
      
    div.d-flex.justify-content-between(v-else v-b-hover="handleHover" :style="hovered ? 'cursor: pointer': ''" @click="toggleEdit" )
      div.text-primary {{ label }}
      div {{ entity[property_name] }}

  b-form-group.m-0.p-1(:label-cols="label_cols" v-if="editing").bg-light
    template(#label)
      div.font8(@click="toggleEdit" style="cursor: pointer;") {{ label }}
    b-form-input(size="sm" v-model="entity[property_name]" :class="validate(property_name)" @update="onUpdate")
    small.invalid-feedback {{validationMessage(property_name)}}
    small(v-if="hint") {{hint}}
</template>

<script>
// import {mapActions, mapGetters} from 'vuex'
import entity_widget from '@/mixins/entity-widget'
export default {
  name: 'EntityTextField',
  
  props:{
    hint: {type: String},
    display_type: {type: String}
  },
  
  mixins:[
    entity_widget
  ],

}
</script>
<style scoped>

</style>